// Change logo if the header is pinned
// Select the element to observe
const announcementBar = document.querySelector('.announcement-bar');
const header = document.querySelector('.shopify-section--header');
const logo = document.querySelector('.header__logo-image--not-sticky');
const stickyLogo = document.querySelector('.header__logo-image--sticky');
const logoWrap = document.querySelector('.header__logo');

// Animation for the rich text section heading
const sectionRichText = document.querySelector('.shopify-section--rich-text');
const iconMovingState = document.querySelector('.rich-text__icon--small');
const iconFinalState = document.querySelector('.rich-text__icon--x-small');

// Create an observer for header and rich text sections animation

window.addEventListener("scroll", () => {
  if (window.innerWidth >= 768) {
    if (window.scrollY > 80) {
      logo.classList.add('visually-hidden');
      stickyLogo.classList.remove('visually-hidden');
      logoWrap.classList.add('sticky');

      iconMovingState?.classList.add('animated');

      setTimeout(() => {
        iconFinalState?.classList.remove("hidden");
        iconMovingState?.classList.add("hidden");
      }, window.innerWidth > 610 ? 10000 : 7000);
    }

    if (window.scrollY < 10) {
      logo.classList.remove('visually-hidden');
      stickyLogo.classList.add('visually-hidden');
      logoWrap.classList.remove('sticky');
    }
  }
});

// Scale animation of elements moving along path
{
  function adjustIconPositions() {
    const icons = document.querySelectorAll('.image-with-text__icon');

    icons.forEach((icon) => {
      const pathImage = icon.closest('image-banner').querySelector('.image-with-text__background');
      const pathWidth = pathImage.clientWidth;
      const pathHeight = pathImage.clientHeight;

      const originalPathMatch = getComputedStyle(icon).offsetPath.match(/path\("(.*)"\)/);
      if (originalPathMatch.length > 1) {
        const originalPath = originalPathMatch[1];

        // Get original X, Y ranges, set scalers
        const originalCoords = originalPath.match(/\d+\.\d*(?:e-?\d+)?/g).map(parseFloat);
        const originalXs = originalCoords.filter((_, idx) => idx % 2 === 0);
        const originalYs = originalCoords.filter((_, idx) => idx % 2 !== 0);
        const ogXMax = Math.max(...originalXs);
        const ogYMax = Math.max(...originalYs);
        const scaleX = (x) => x / ogXMax * pathWidth;
        const scaleY = (y) => y / ogYMax * pathHeight;

        // Transform path
        let xFlag = true;
        const scaledPath = originalPath.split(" ").map((token) => {
          // Use the global isNaN() here, we want to coerce numeric strings to floats
          if (isNaN(token)) {
            return token;
          } else {
            const scaler = xFlag ? scaleX : scaleY;
            xFlag = !xFlag;
            return `${scaler(parseFloat(token)).toFixed(2)}`;
          }
        }).join(" ");

        icon.style.offsetPath = `path("${scaledPath}")`;
      }
    });
  }

  // Create an observer instance with a callback function
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        adjustIconPositions();
        observer.unobserve(entry.target);
      }
    });
  });

  // Specify the target elements to observe with the class name
  const targetElements = document.querySelectorAll('.shopify-section--image-with-text-overlay');

  // Start observing each target element
  targetElements.forEach((element) => {
    observer.observe(element);
  });
}

// Open pop-up with shipping policy

{
  const policyBtn = document.getElementById("open-policy");
  const overlay = document.querySelector(".overlay");
  const policy = document.querySelector(".policy-modal");

  policyBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    policy.classList.add("open");
    document.documentElement.classList.add('lock');
  })

  overlay?.addEventListener("click", function (e) {
    document.documentElement.classList.remove('lock');
    policy.classList.remove("open");
  })
}

// Landing page buttons logic
{
  const copyButton = document.querySelector('.copy-link-button');

  copyButton?.addEventListener('click', function(e) {
    e.preventDefault();

    const hrefValue = this.getAttribute('href');

    // Create a temporary input element with href value
    const tempInput = document.createElement('input');
    tempInput.setAttribute('value', hrefValue);
    document.body.appendChild(tempInput);

    // Select the input element's value and copy
    tempInput.select();
    document.execCommand('copy');

    // Remove the temporary input element
    document.body.removeChild(tempInput);

    alert('Link copied to clipboard: ' + hrefValue);
  }); 
}

{
    // *** BundleSuite App ***

    class BundleSuiteContainerManager {
        constructor(bundleSuiteContainerElement) {
            this.container = bundleSuiteContainerElement;

            // collectionSections and itemTitleToSection are
            // initialized on demand. They are properly accessed with getters.

            this._collectionSections = null;
            this._itemTitleToSection = null;
        }

        initialize() {
            this.container.addEventListener('click', this.handleContainerClick.bind(this));
            this.markElementWhenInViewport('.side-cart-checkout', 'bundle-checkout-button-in-viewport');
            this.markElementWhenInViewport('.side-cart-product-container', 'bundle-side-cart-in-viewport');
            this.modifySectionsOnCreation();
        }

        modifySectionsOnCreation() {
            const modifySection = (section) => {
                // Reword title

                const titleNode = section.querySelector('.section-title');
                if (titleNode) {
                    titleNode.innerHTML = (
                        titleNode.innerHTML.replace(
                            'minimum 1 products and maximum 1 products', 'a product'
                        )
                        .replace(/minimum (\d+) products and maximum (\1) products/g, '$1 products')
                        .replace(/minimum (\d+) products and maximum (\d+) products/g, '$1 to $2 products')
                        .replace(/minimum (\d+) products/g, '$1 or more products')
                        .replace(/maximum 1 products/g, 'a product (optional)')
                        .replace(/maximum (\d+) products/g, 'up to $1 products')
                    );
                }

                // Add click listeners to direct add-to-cart buttons.
                // The button listeners stop event propagation, so the clicks
                // cannot be delegated. The buttons also don't exist yet, so observe
                // the product container for product cards.

                const productsContainer = section.querySelector('.individual-products-container, .collection-container');
                const productsContainerObserver = new MutationObserver((mutationsList) => {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(node => {
                                if (
                                    node.nodeType === Node.ELEMENT_NODE
                                    && node.classList.contains('product-card')
                                ) {
                                    const atcButton = node.querySelector('.add-button');
                                    if (atcButton) {
                                      atcButton.addEventListener('click', event => {
                                        event.stopPropagation();
                                        const productCardWrapper = atcButton.closest('.product-card-wrapper');
                                        if (productCardWrapper) {
                                            // The only thing to hook into is the item title.
                                            const itemTitle = productCardWrapper
                                                .querySelector('.product-title h4')?.textContent.trim();
                                            this.handleAddingBundleItem(itemTitle);
                                        } else {
                                            console.error('Error in advance-section routine: no product card wrapper');
                                        }
                                      })
                                    }
                                }
                            });
                        }
                    }
                });

                productsContainerObserver.observe(productsContainer, { childList: true, subtree: true });
            };

            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(node => {
                            if (
                                node.nodeType === Node.ELEMENT_NODE
                                && (
                                  node.classList.contains('collection-section')
                                  || node.classList.contains('individual-products-section')
                                )
                            ) {
                                modifySection(node);
                            }
                        });
                    }
                }
            });

            observer.observe(this.container, { childList: true, subtree: true });
        }

        /**
         * Set up an intersection observer to mark an element with a CSS class when it's in the viewport.
         *
         * The element to mark is specified by a CSS selector, the first element matching the selector will
         * be observed. The CSS class is added to the element whenever it appears in the viewport (typically
         * when scrolled to). The CSS class is removed from the element whenever it leaves the viewport.
         * @param {String} selector CSS selector of the element, relative to the bundle container.
         * @param {String} className CSS class to apply.
         */
        markElementWhenInViewport(selector, className) {
            const elementToDetect = this.container.querySelector(selector);
            if (elementToDetect) {
                const xObserver = new IntersectionObserver(
                    (entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                document.body.classList.add(className);
                            } else {
                                document.body.classList.remove(className);
                            }
                        });
                    },
                    {
                        root: null,
                        threshold: 0.01
                    }
                );

                xObserver.observe(elementToDetect);
            }
        };

        get hasSideDock() {
            return window.innerWidth >= 1200;
        }

        get collectionSections() {
            if(this._collectionSections === null) {
                this.populateDataStructures();
            }
            return this._collectionSections;
        }

        get itemTitleToSection() {
            if(this._itemTitleToSection === null) {
                this.populateDataStructures();
            }
            return this._itemTitleToSection;
        }

        populateDataStructures() {
            if (this._collectionSections !== null) {
                // Skip if structures are already populated.
                return;
            }

            this._collectionSections = [];
            this._itemTitleToSection = new Map();

            this.container
            .querySelectorAll('.collection-section, .individual-products-section')
            .forEach((section) => {
                this._collectionSections.push(section);
                section
                .querySelectorAll('.product-card')
                .forEach((productCard) => {
                    const title = productCard.querySelector('.product-title')?.textContent;
                    if (title) {
                        this._itemTitleToSection.set(title.trim(), section);
                    }
                });
            })
        }

        handleAddingBundleItem(itemTitle) {
            const recentSection = this.itemTitleToSection.get(itemTitle);
            const recentSectionIndex = this.collectionSections.findIndex(
                (item) => item === recentSection
            );

            // Iterate through sections cyclically, starting from the next one.
            // Look for a section that has enabled AtC buttons and scroll it into view.

            let i = 1;
            for (; i < this.collectionSections.length; i++) {
                const sectionIndex = (recentSectionIndex + i) % this.collectionSections.length;
                const section = this.collectionSections[sectionIndex];
                const firstAddButton = section.querySelector('.product-card .add-button');
                if (firstAddButton && !firstAddButton.classList.contains('disabled')) {
                    section.scrollIntoView({behavior: 'smooth'});
                    break;
                }
            }

            // Scroll to the cart menu when all items are exhausted. Since the cart
            // menu is bottom-sticky on mobile, scroll underneath <main>*, and
            // the menu will dock there. On desktop the cart menu is always available
            // in the side dock.
            //
            // * WARNING: this may be theme-dependent because of <main>

            if (i === this.collectionSections.length) {
                const mainElement = document.querySelector('main');
                if (mainElement && !this.hasSideDock) {
                    const rect = mainElement.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const targetScroll = rect.bottom + scrollTop;
                    window.scrollTo({ top: targetScroll, behavior: 'smooth' });
                }
            }
        }

        handleContainerClick(event) {
            // Delegate add-to-cart button clicks.
            // Works only for products with variants.
            // For products with no variants, see the cumbersome solution in modifySectionsOnCreation()

            if (
                event.target.tagName == 'BUTTON'
                && event.target.parentNode.classList.contains('product-variant-selector-cta')
            ) {
                const variantSelectorBody = event.target.closest('.product-variant-selector-body');
                if (variantSelectorBody) {
                    // The only thing to hook into is the item title.
                    const itemTitle = variantSelectorBody
                        .querySelector('.product-variant-selector-header-title h3')?.textContent;
                    this.handleAddingBundleItem(itemTitle);
                } else {
                    console.error('Error in advance-section routine: no variant selector body');
                }
            }
        }
    }

    document.querySelectorAll('.bundlesuite-container')
    .forEach((bundleSuiteContainer) => {
        (new BundleSuiteContainerManager(bundleSuiteContainer)).initialize();
    });
}
